import * as React from 'react';
import PlusSmallOutlined from './plus-small-outlined';
import PlusSmallFilled from './plus-small-filled';
import type { IconCombinedProps } from './types';
const PlusSmallCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <PlusSmallFilled ref={ref} {...rest} />;
  }
  return <PlusSmallOutlined ref={ref} {...rest} />;
});
export default PlusSmallCombined;